import { Component, Host, h, State, Prop } from '@stencil/core';
import { waitForElm } from '../../global/app';

import { isPlatform } from '@baloise/ds-core';

@Component({
  tag: 'bam-skiplink',
  styleUrl: 'bam-skiplink.scss',
  shadow: false,
})
export class BamSkiplink {
  @Prop() btnText: string;
  @Prop() href?: string;
  @Prop() type?: string;
  @State() isHidden: boolean = false;

  private metaBarSearchButton: HTMLBalButtonElement;
  private menuTabs: HTMLDivElement;
  private isMobile = isPlatform('mobile') || isPlatform('tablet');

  async componentDidLoad() {
    const metaBar = (await waitForElm('bal-nav-meta-bar')) as HTMLBalNavMetaBarElement;
    this.menuTabs = (await waitForElm('bal-nav-menu-bar bal-tabs bal-carousel .bal-carousel__inner__container')) as HTMLDivElement;
      
    const metaBarButtonsWrapper = this.isMobile
      ? (metaBar?.querySelector('bal-stack') as HTMLBalStackElement)
      : (metaBar?.querySelector('#bal-nav__meta-buttons') as HTMLBalStackElement);
    const metaBarButtons = Array.from(metaBarButtonsWrapper?.querySelectorAll('bal-button')) as HTMLBalButtonElement[];
    this.metaBarSearchButton = metaBarButtons?.filter(item => item.hasAttribute('bal-popup') && item.getAttribute('bal-popup') == 'popup-search')[0];
    if (this.metaBarSearchButton === undefined && this.type === 'search') {
      this.isHidden = true;
    }
  }

  handleClick = () => {
    if(this.type === 'search') {
      this.metaBarSearchButton?.querySelector('button')?.focus();
    } else if(this.type === 'navigation') {
      (this.menuTabs.querySelector('bal-carousel-item button') as HTMLElement).focus()
    }
  }

  render() {
    const TagType = this.href === undefined ? 'button' : 'a'
    return (
      <Host>
        <TagType onClick={this.handleClick} class={{ 'hidden': this.isHidden}} aria-hidden={this.isHidden ? 'true' : 'false'} {...this.href && {href: this.href}}>
          {this.btnText}
        </TagType>
      </Host>
    );
  }
}
